<template>
  <div
    style="width: 100%; min-height: 100vh; display: flex;
    align-items: stretch;
    flex-direction: column;"
  >
    <div style="height: 50px" class="livehead">
      <div class="text-center">{{ userid }}</div>
    </div>
    <div
      class=" text-center"
      style="
        margin-left: auto;
        margin-right: auto;
        position: relative;
        flex-grow: 1;
        display: flex;
        width: 100%;
        flex-direction: column;
      "
    >
      <perfect-scrollbar
        id="chatbox"
        class="elevation-1 "
        style="background-color: white; height: 300px; overflow: auto;=position: relative; flex-grow: 1"
      >
        <div class="pa-3 chatboxinside">
          <transition-group name="list" tag="div">
            <div v-for="(message, k) in messages" :key="k" :class="`messageitem-` + message.actor">
              <template v-if="message.text !== 'zwiz_welcome'">
                <div :class="message.actor == 'answer' ? `mr-2` : 'ml-2'">
                  <v-avatar size="40px" color="#efefef">
                    <!-- <v-icon v-if="message.type == 'question'" size="30px"
                      >mdi-face-agent</v-icon
                    > -->
                    <v-img v-if="message.actor == 'answer'" src="../assets/mitsuicon.png"></v-img>
                    <v-icon color="grey" v-else size="30px">mdi-account</v-icon>
                  </v-avatar>
                </div>
                <div>
                  <message-bubble
                    @sendMessage="sendMessage"
                    :message="message"
                    @showDivision="showDivision = true"
                  />
                </div>
              </template>
            </div>
          </transition-group>
        </div>
        <template v-if="quick_replies && quick_replies.length">
          <div style="height: 64px"></div>
        </template>
      </perfect-scrollbar>

      <div style=" position: relative">
        <div
          v-if="showToBottom"
          class="text-center "
          style="position: absolute; top: -84px; width: 100%"
        >
          <v-btn @click="scrollToBottom" icon elevation="2" small>
            <v-icon>mdi-chevron-double-down</v-icon>
          </v-btn>
        </div>
        <div
          style="
          position: absolute;
          top: -44px;
          width: 100%;
          overflow-x: auto;
          height: 44px;
          overflow-y: hidden;
          display: flex;
          justify-content: left;
          align-items: flex-start;
        "
          class="text-center"
        >
          <v-btn
            small
            @click="
              sendMessage({
                title: item,
                payload: item
              })
              quick_replies = ''
            "
            dense
            v-ripple
            style="
            background-color: white;
            border: 1px solid rgb(255 82 82);
            border-radius: 12px;
            color: #ff6666;
          "
            class="mx-2 px-3 text-capitalize"
            v-for="(item, k) in quick_replies"
            :key="k"
            >{{ item }}</v-btn
          >
        </div>
        <v-card>
          <v-text-field
            @keyup.enter="
              sendMessage({
                title: input,
                payload: input
              })
            "
            hide-actions
            v-model="input"
            hide-details
            class="mb-0"
            placeholder="Type a message..."
            flat
            solo
          >
            <template v-slot:append>
              <v-btn
                @click="
                  sendMessage({
                    title: input,
                    payload: input
                  })
                "
                style="width: 120px"
                color="#d80000"
                dark
                >send</v-btn
              >
            </template>
          </v-text-field>
        </v-card>
      </div>
    </div>

    <SelectDivision v-model="showDivision" @sendMessage="sendMessage" />
  </div>
</template>

<script>
import Chatbox from './Chatbox.js'
export default {
  mixins: [Chatbox]
}
</script>

<style lang="scss">
.ps__rail-x,
.ps__rail-y {
  opacity: 0.6;
}
.ps-container > .ps-scrollbar-x-rail,
.ps-container > .ps-scrollbar-y-rail {
  opacity: 0.6;
}
.messageitem-question {
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 16px;
}
.messageitem-answer {
  flex-direction: row;
  display: flex;
  margin-bottom: 16px;
}
.livehead {
  background-color: #ce1a26;
  color: white;
  padding: 13px;
}
.wrapchat {
  // max-width: 600px;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(20px);
}

.tobottom {
  position: absolute;
  bottom: 65px;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
